import styled from 'styled-components';

export const SelectionOptionsTitle = styled.legend`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.base};
  font-size: 0.9375rem;
  font-weight: ${Styles.fontWeight.heavy};
  padding: 0;
`;
